import { type } from 'arktype'

import { subscriptionStepIdSchema, type SubscriptionStepId } from '@orus.eu/dimensions'

const FUNNEL_RETURN_PREFIX = 'funnel/'

/** Without `return`, the result screen is terminal. */
export const standaloneFormSearchSchema = type({
  'return?': type('string').narrow(
    (value, context) => funnelReturnStepId(value) !== undefined || context.mustBe('a funnel step to return to'),
  ),
})

export type StandaloneFormReturn = NonNullable<typeof standaloneFormSearchSchema.infer.return>

/** Undefined for a value that names no funnel step. */
export function funnelReturnStepId(value: string): SubscriptionStepId | undefined {
  if (!value.startsWith(FUNNEL_RETURN_PREFIX)) return undefined
  const stepId = subscriptionStepIdSchema(value.slice(FUNNEL_RETURN_PREFIX.length))
  return stepId instanceof type.errors ? undefined : stepId
}
